<template>
  <div class="AD bc-white padding2" v-title data-title="公告列表">
    <div class="row justify-content-around pr10 pl10 pt5 pb5">
      <van-button @click="back" class="btn-common" plain type="info">返回</van-button>
      <!-- <van-button @click="saveNotice" class="btn-common" type="info">保存</van-button> -->
    </div>
    <div class="mt10 pl7 pr7 text-center">
      <van-button round block type="info" @click="edit()">
        新增公告
      </van-button>
    </div>
    <template v-for="(notice, index) in datas">
      <div :key="index+'_line'" class="line mt7"></div>
      <div :key="index+'_content'" class="notice-item mt5 row align-items-center pt4 pb1 pl1">
        <div class="fs2 flex-1 text-left">
          <div class="fc-primary pt1"><span class="fs1 fc-less">位置：</span>{{getPositionName(notice.position) ||'未知'}}</div>
          <div class="fc-primary pb1"><span class="fs1 fc-less">内容：</span>{{notice.content || ''}}</div>
        </div>
        <div class="fc-danger pl2 pr2">
          <div class="pb1"><van-button plain round type="danger" size="mini"
          @click.stop="deleteImage(notice)">删除</van-button></div>
          <div class=""><van-button plain round type="info" size="mini"
          @click.stop="edit(notice)">修改</van-button></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import { NOTICE_TYPES } from '@/uitls/const';
import config from '../../config';
import {
  sendRequest, deletenotice, getnotices,
} from '../../network/NetworkAccessor';

export default Vue.extend({
  name: 'AD',
  components: {},
  data() {
    return {
      loading: false,
      fileDomain: config.FILE_DOMAIN,
      positions: {
        1: '顶部',
        2: '中间',
      },
      types: {
        1: '龙虾',
        2: '螃蟹',
      },
      datas: [],
    };
  },
  methods: {
    getPositionName(value) {
      return (NOTICE_TYPES.find(item => item.value === value) || {}).text;
    },
    deleteImage(item = {}) {
      this.$dialog.confirm({
        title: '删除',
        message: '确定删除吗？',
      }).then(() => {
        // on confirm
        sendRequest(deletenotice, {
          id: item.id,
        }).then((res) => {
          // console.log(res);
          this.datas = this.datas.filter(d => d.id !== item.id);
          this.$dialog.alert({
            message: '已删除',
          });
        }).catch((e) => {
          console.log(e);
          this.$dialog.alert({
            message: e.message || '啊哦，出错了',
          });
        });
      }).catch(() => {
        // on cancel
      });
    },
    edit(item = {}) {
      this.$router.push(`/notice/edit/${item.id || ''}`);
    },
    getAD() {
      sendRequest(getnotices, {}).then((res) => {
        // console.log(res);
        this.datas = res || [];
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: e.message || '啊哦，出错了',
        });
      });
    },
    back() {
      this.$router.back();
    },
  },
  created() {
    this.getAD();
  },
});
</script>
<style scoped>
  .AD {
    min-height: 100vh;
  }
  .add {
    width: 200px;
    height: 100px;
    line-height: 110px;
    border: 1px dashed #2c2c2c;
    margin: 15px auto;
  }
  .ad-item {
    border-radius: 6px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
</style>
